import axiosInstance from "../axiosInterceptor";

export async function getAllSubject() {
  const response = await axiosInstance.get(`/student/getAllSubject`);
  const data = response?.data;
  return data;
}
